import { IonCol, IonIcon, IonRippleEffect, IonRow } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import classes from './styles.module.scss';
import { isLoggedIn } from '../../../../utils/isLoggedIn';
import Menu from '../../../storeMenu/menu';
import { User } from '../../../../types/user';
import logo from '../../../../Assets/logo/logo_white_background_96.svg';
import { menuOutline } from 'ionicons/icons';
import { menuController } from '@ionic/core/components';
import { hideMenuPaths } from '../../../../utils';
import { IoCartOutline, IoMenu } from 'react-icons/io5';
import useGlobalContext from '../../../../hooks/useStore';
import classNames from 'classnames';

const Mobile = ({
  user,
  backgroundColor = 'white',
}: {
  user: User;
  backgroundColor?: 'primary' | 'white' | 'transparent';
}) => {
  const history = useHistory();
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const isloggedIn = isLoggedIn();
  const globalState = useGlobalContext();
  const [openDropDown, setOpenDropDown] = useState<{
    isOpen: boolean;
    event: Event | null;
  }>({
    isOpen: false,
    event: null,
  });

  useEffect(() => {
    const closeMenu = async () => {
      if (openMenu && hideMenuPaths.includes(location.pathname)) {
        await menuController.close('menu');
      }
    };

    closeMenu();
  }, [location.pathname, openMenu]);

  const openCntx = (e: any) => {
    setOpenDropDown({ isOpen: !openDropDown.isOpen, event: e });
  };
  return (
    <div className={'w-full h-full flex items-center px-4'}>
      {/* {isloggedIn && (
        <Menu
          open={openDropDown.isOpen}
          close={openCntx}
          userDetails={user}
          openEvent={openDropDown.event!}
        />
      )} */}

      <div
        onClick={() => {
          history.push('/');
        }}
        className="w-auto h-fit  flex items-center"
      >
        <div className="w-auto h-12 aspect-square flex items-center justify-center">
          <img src={logo} alt="logo" className="size-full" />
        </div>
        <span className="text-primary text-xl font-roboto font-bold ">
          Bazaar
        </span>{' '}
        <span className="text-secondary text-xl font-roboto font-semibold ml-[2px] italic ">
          Cheap
        </span>
      </div>

      {/* <IonCol size="2">
          {isloggedIn && (
            <div className={classes.chip}>
              <StoreMenu
                userDetails={user}
                open={openDropDown.isOpen}
                openCntx={openCntx}
              />
            </div>
          )}
        </IonCol> */}
      {!location.pathname.includes('cart') && (
        <div className="w-fit h-full grid grid-cols-2 grid-flow-col-dense ml-auto mr-[5px]">
          <div
            onClick={async () => {
              history.push('/cart');
            }}
            className="ml-auto size-10 my-auto flex items-center justify-center cursor-pointer ion-activatable ripple-parent circle rounded-full relative p-[0.5%] overflow-hidden"
          >
            <IonRippleEffect />
            <IoCartOutline
              size="100%"
              className="text-primary w-auto h-8 aspect-square"
            />
          </div>
          {globalState.cartState.count ? (
            <div className="mt-[1.4dvh] w-fit h-fit px-2 text-gray-50 font-roboto font-semibold rounded-full bg-primary flex items-center justify-center text-xs">
              {globalState.cartState.count}
            </div>
          ) : (
            ''
          )}
        </div>
      )}

      <div
        onClick={async () => {
          await menuController.open('menu');
          setOpenMenu(await menuController.isOpen('menu'));
        }}
        className={
          ' w-auto h-8 aspect-square flex items-center justify-center cursor-pointer ion-activatable ripple-parent circle rounded-full relative overflow-hidden p-[0.5%] ' +
          classNames({ 'ml-auto': location.pathname.includes('cart') })
        }
      >
        <IonRippleEffect />
        <IoMenu size="100%" className="text-primary" />
      </div>
    </div>
  );
};

export default Mobile;
